// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCallistoNotConnected_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 2H24V13.75C23.4265 13.148 22.7505 12.6445 22 12.2675V4H2V16H12.0397C11.7823 16.6274 11.6104 17.2989 11.5383 18H0V2Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.3945 16.3001C23.6698 16.821 23.8601 17.3938 23.9468 18C23.9819 18.245 24 18.4954 24 18.75C24 21.6495 21.6495 24 18.75 24C17.0777 24 15.588 23.2181 14.6266 22C14.5467 21.8988 14.4705 21.7946 14.3981 21.6876C14.2921 21.5308 14.1943 21.3679 14.1054 21.1997C13.907 20.8244 13.7528 20.4222 13.6497 20C13.5519 19.5994 13.5 19.1808 13.5 18.75C13.5 18.4954 13.5181 18.245 13.5532 18C13.6569 17.275 13.9087 16.5978 14.277 16C15.2012 14.5 16.8588 13.5 18.75 13.5C19.9772 13.5 21.1061 13.9211 22 14.6266C22.4254 14.9623 22.7975 15.3625 23.1018 15.8123C23.2078 15.9691 23.3056 16.1319 23.3945 16.3001ZM15.8557 20.2299C15.8173 20.1549 15.7817 20.0782 15.7491 20C15.5886 19.6152 15.5 19.193 15.5 18.75C15.5 18.4919 15.5301 18.2408 15.587 18C15.6265 17.8326 15.679 17.6702 15.7433 17.514C16.0014 16.8868 16.45 16.3581 17.0172 16C17.5187 15.6833 18.113 15.5 18.75 15.5C19.283 15.5 19.7861 15.6283 20.2299 15.8557L15.8557 20.2299ZM17.2699 21.6442C17.7138 21.8717 18.2169 22 18.75 22C20.5449 22 22 20.5449 22 18.75C22 18.4919 21.9699 18.2408 21.913 18C21.8525 17.7436 21.7615 17.4989 21.6442 17.27L17.2699 21.6442Z" class="svg-bg"/>
  <path d="M12.2675 22C11.9556 21.3791 11.7302 20.7071 11.6074 20H8L7 22H12.2675Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 3H32V19.3427C31.4299 18.6381 30.7555 18.0214 30.0004 17.5158V4.99996H2.00044V23H16.223C16.0771 23.6432 16 24.3126 16 25H0V3ZM16.9355 29C16.6232 28.3715 16.3822 27.7013 16.223 27H10L9 29H16.9355Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 25C32 28.866 28.866 32 25 32C21.134 32 18 28.866 18 25C18 21.134 21.134 18 25 18C28.866 18 32 21.134 32 25ZM30 25C30 27.7614 27.7614 30 25 30C23.9808 30 23.0329 29.6951 22.2424 29.1715L29.1715 22.2424C29.6951 23.0329 30 23.9808 30 25ZM20.8283 27.7572C20.3048 26.9668 20 26.019 20 25C20 22.2386 22.2386 20 25 20C26.019 20 26.9668 20.3048 27.7572 20.8283L20.8283 27.7572Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCallistoNotConnected is a generated icon component.
 */
let IconMedCallistoNotConnected = IconMedCallistoNotConnected_1 = class IconMedCallistoNotConnected extends IconBaseElement {
    render() {
        return html `${IconMedCallistoNotConnected_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCallistoNotConnected.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedCallistoNotConnected = IconMedCallistoNotConnected_1 = __decorate([
    customElement('zui-icon-med-callisto-not-connected')
], IconMedCallistoNotConnected);
export { IconMedCallistoNotConnected };
